<template>
  <v-container>
    <!-- ----------------------------------------------------------- -->
    <div v-if="loading" class="mx-auto my-auto" style="width: fit-content">
      <v-progress-circular
        size="50"
        width="4"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-card elevation="1" v-if="!loading" max_height="650" class="pa-4">
      <v-card-title class="text-center text-h5"> Training Score </v-card-title>
      <v-card-text>
        <v-select
          v-model="targeted_languages"
          :items="languages"
          label="Select"
          chips
          hint="languages"
          persistent-hint
        ></v-select
      ></v-card-text>

      <app-chart :chartData="chart_data"></app-chart>
    </v-card>
  </v-container>
</template>
<script>
import LineChart from "../components/LineChart";
import moment from "moment";
import { axios } from "../main";
export default {
  name: "Stats",
  data() {
    return {
      stats: undefined,
      loading: true,
      languages: [],
      targeted_languages: undefined,
    };
  },
  computed: {
    chart_data: {
      get() {
        let options = {};

        if (this.stats) {
          options = {
            labels: this.stats[this.targeted_languages].dates,
            datasets: [
              {
                label: this.targeted_languages,
                // backgroundColor: '#00a99e',
                borderColor: "#00a99e",
                data: this.stats[this.targeted_languages].scores,
                borderWidth: 2,
                fill: false,

                lineTension: 0.1,
              },
            ],
          };
        }

        return options;
      },
    },
  },
  mounted() {
    this.getStats();
  },
  methods: {
    async getStats() {
      let stats = undefined;
      try {
        stats = await axios.get("/getMyStats");
        stats = stats.data.stats;
      } catch (err) {
        console.log(err);
      }
      let stats_by_lang = {};
      let counter = 0;
      if (stats) {
        for (let stat of stats) {
          stat.learningLanguage =
            stat.learningLanguage || counter % 2 == 0 ? "en" : "fr";

          if (!stats_by_lang[stat.learningLanguage]) {
            stats_by_lang[stat.learningLanguage] = { scores: [], dates: [] };
          }
          stats_by_lang[stat.learningLanguage].scores.push(stat.score);
          stats_by_lang[stat.learningLanguage].dates.push(
            moment.unix(stat.date / 1000).format("DD/MM/YYYY HH:MM")
          );
          counter++;
        }
        this.languages = Object.keys(stats_by_lang);
        this.targeted_languages = this.languages[0];
        this.stats = stats_by_lang;
        this.loading = false;
      }
    },
  },
  components: {
    "app-chart": LineChart,
  },
};
</script>
